import { toLower } from "ramda";
import { ADDCARD, TOS, ADDPM, TXNHISTORY, TXNDETAILS } from "flows/constants";
import { extractLangFromLocale, defaultLanguage } from "utils/LanguageProvider/utils";

export const READY_FLOWS = [ADDCARD, TOS, ADDPM, TXNHISTORY, TXNDETAILS].map(toLower);

/**
 * @function isFlowEnabled A utility for optionally adding settings-based override to
 * enabled flows.
 * @param {*} settings from settings API
 * @returns function to test flow if enabled
 */
export const isFlowEnabled = (flow) => {
  if (typeof flow === "string") {
    return READY_FLOWS.includes(flow.toLowerCase());
  } else {
    return false;
  }
};

/**
 * @function modelLanguageOptionsFromSettings Create UI options from Publisher language settings
 * @param {string[]} languages List of language codes from Publisher settings
 * @param {function} getMaintainedLocales Getter for maintained locale values
 * @returns {{ label: string; value: string }[]} List of options for UI elements
 */
export const modelLanguageOptionsFromSettings = (languages, maintainedLanguages) => {
  if (!languages.includes(defaultLanguage)) {
    languages.push(defaultLanguage);
  }
  languages.sort();
  const availableLanguages = languages.reduce((availableLanguages, supportedLanguage) => {
    const availableLanguage = maintainedLanguages[extractLangFromLocale(supportedLanguage)];
    if (availableLanguage) {
      availableLanguages.push(availableLanguage);
    }
    return availableLanguages;
  }, []);

  return availableLanguages.map(({ locale, name }) => ({
    label: name,
    value: locale,
  }));
};
